import { useState } from 'react'
import ExclamationTriangleIcon from '@icons/exclamation-triangle'
import { cn } from '@/lib/misc/Utils'
import { AppService } from '@/lib/services/AppService'
import { Notify } from '@/lib/misc/Notify'
import CheckCircleIcon from '@icons/check-circle'
import Button from './Button'

const EmailVerificationBanner = () => {
  const [isResendingEmail, setIsResendingEmail] = useState(false)
  const [hasResentEmail, setHasResentEmail] = useState(false)

  const handleResendVerificationEmail = async () => {
    setIsResendingEmail(true)

    try {
      const appService = new AppService()
      await appService.resendVerificationEmail()
      Notify.success('Verification email sent successfully!')
      setHasResentEmail(true)
    } catch {
      Notify.error('Failed to send verification email. Please try again.')
    } finally {
      setIsResendingEmail(false)
    }
  }

  return (
    <div>
      <div
        className={cn(
          'border-status-warning  bg-status-warning p-1.5 rounded-t-xl'
        )}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <ExclamationTriangleIcon className="size-6 text-white" />
            <span className="text-white">
              Please verify your email address to access all features.
            </span>
          </div>
          <div className="flex flex-col items-end gap-2">
            {hasResentEmail ? (
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="w-6 h-6 text-status-good" />
                <span className="text-neutral-60">
                  Verification email sent successfully!
                </span>
              </div>
            ) : (
              <Button
                style="flat"
                onClick={handleResendVerificationEmail}
                disabled={isResendingEmail}
              >
                {isResendingEmail ? 'Sending...' : 'Resend Email'}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmailVerificationBanner
